import React, { useState, useEffect, useMemo } from 'react';
import { Container, Row, Col, Card, Button, Modal, Form, Table, Badge, Pagination } from 'react-bootstrap';
import TPinModal from '../../../components/common/TPinModal';
import showToast from '../../../utils/toast';

const PayoutBeneficiary = () => {
  const [showModal, setShowModal] = useState(false);
  const [activeTab, setActiveTab] = useState('Approved');
  const [formData, setFormData] = useState({
    accountNumber: '',
    confirmAccountNumber: '',
    ifscCode: '',
    name: '',
    bankName: '',
    branchName: '',
    cancelCheque: null
  });

  // Sample beneficiary data
  const [beneficiaries] = useState([
    {
      id: 1,
      status: 'Approved',
      accountNumber: '1234567890',
      ifscCode: 'HDFC0001234',
      name: 'Rajesh Kumar',
      uniqueId: 'BEN001',
      cancelCheque: 'cheque_001.pdf',
      bankName: 'HDFC Bank'
    },
    {
      id: 2,
      status: 'Approved',
      accountNumber: '9876543210',
      ifscCode: 'ICIC0005678',
      name: 'Priya Sharma',
      uniqueId: 'BEN002',
      cancelCheque: 'cheque_002.pdf',
      bankName: 'ICICI Bank'
    },
    {
      id: 3,
      status: 'Pending',
      accountNumber: '4567891230',
      ifscCode: 'SBIN0001234',
      name: 'Amit Patel',
      uniqueId: 'BEN003',
      cancelCheque: 'cheque_003.pdf',
      bankName: 'State Bank of India'
    },
    {
      id: 4,
      status: 'Rejected',
      accountNumber: '7894561230',
      ifscCode: 'AXIS0009876',
      name: 'Sneha Reddy',
      uniqueId: 'BEN004',
      cancelCheque: 'cheque_004.pdf',
      bankName: 'Axis Bank'
    },
    {
      id: 5,
      status: 'Pending',
      accountNumber: '3216549870',
      ifscCode: 'PUNB0012345',
      name: 'Vikram Singh',
      uniqueId: 'BEN005',
      cancelCheque: 'cheque_005.pdf',
      bankName: 'Punjab National Bank'
    },
    {
      id: 6,
      status: 'Pending',
      accountNumber: '6549873210',
      ifscCode: 'YESB0004321',
      name: 'Neha Verma',
      uniqueId: 'BEN006',
      cancelCheque: 'cheque_006.pdf',
      bankName: 'Yes Bank'
    },
    {
      id: 7,
      status: 'Pending',
      accountNumber: '8523697412',
      ifscCode: 'KARB0001234',
      name: 'Suresh Pillai',
      uniqueId: 'BEN007',
      cancelCheque: 'cheque_007.pdf',
      bankName: 'Karur Vysya Bank'
    },
    {
      id: 8,
      status: 'Pending',
      accountNumber: '9632587410',
      ifscCode: 'CNRB0004567',
      name: 'Sunita Chauhan',
      uniqueId: 'BEN008',
      cancelCheque: 'cheque_008.pdf',
      bankName: 'Canara Bank'
    },
    {
      id: 9,
      status: 'Pending',
      accountNumber: '7412589630',
      ifscCode: 'UBIN0009876',
      name: 'Pankaj Mehta',
      uniqueId: 'BEN009',
      cancelCheque: 'cheque_009.pdf',
      bankName: 'Union Bank'
    },
    {
      id: 10,
      status: 'Pending',
      accountNumber: '3692581470',
      ifscCode: 'BARB0DEL123',
      name: 'Kavita Bansal',
      uniqueId: 'BEN010',
      cancelCheque: 'cheque_010.pdf',
      bankName: 'Bank of Baroda'
    },
    {
      id: 11,
      status: 'Pending',
      accountNumber: '2581473690',
      ifscCode: 'UTIB0006543',
      name: 'Nikhil Sharma',
      uniqueId: 'BEN011',
      cancelCheque: 'cheque_011.pdf',
      bankName: 'Axis Bank'
    },
    {
      id: 12,
      status: 'Pending',
      accountNumber: '1478523690',
      ifscCode: 'SBIN0007654',
      name: 'Ritika Das',
      uniqueId: 'BEN012',
      cancelCheque: 'cheque_012.pdf',
      bankName: 'State Bank of India'
    },
    {
      id: 13,
      status: 'Pending',
      accountNumber: '9871236540',
      ifscCode: 'ICIC0008765',
      name: 'Aniket Kulkarni',
      uniqueId: 'BEN013',
      cancelCheque: 'cheque_013.pdf',
      bankName: 'ICICI Bank'
    },
    {
      id: 14,
      status: 'Pending',
      accountNumber: '3217896540',
      ifscCode: 'HDFC0005432',
      name: 'Rohit Saini',
      uniqueId: 'BEN014',
      cancelCheque: 'cheque_014.pdf',
      bankName: 'HDFC Bank'
    },
    {
      id: 15,
      status: 'Pending',
      accountNumber: '8521479630',
      ifscCode: 'PUNB0019876',
      name: 'Shalini Gupta',
      uniqueId: 'BEN015',
      cancelCheque: 'cheque_015.pdf',
      bankName: 'Punjab National Bank'
    },
    {
      id: 16,
      status: 'Pending',
      accountNumber: '9637412580',
      ifscCode: 'SBIN0012345',
      name: 'Harish Joshi',
      uniqueId: 'BEN016',
      cancelCheque: 'cheque_016.pdf',
      bankName: 'State Bank of India'
    },
    {
      id: 17,
      status: 'Pending',
      accountNumber: '7419638520',
      ifscCode: 'KKBK0003214',
      name: 'Payal Desai',
      uniqueId: 'BEN017',
      cancelCheque: 'cheque_017.pdf',
      bankName: 'Kotak Mahindra Bank'
    },
    {
      id: 18,
      status: 'Pending',
      accountNumber: '3697418520',
      ifscCode: 'INDB0006547',
      name: 'Gagan Ahuja',
      uniqueId: 'BEN018',
      cancelCheque: 'cheque_018.pdf',
      bankName: 'IndusInd Bank'
    },
    {
      id: 19,
      status: 'Pending',
      accountNumber: '2589631470',
      ifscCode: 'IDFB0043210',
      name: 'Meenal Shah',
      uniqueId: 'BEN019',
      cancelCheque: 'cheque_019.pdf',
      bankName: 'IDFC First Bank'
    },
    {
      id: 20,
      status: 'Pending',
      accountNumber: '1473692580',
      ifscCode: 'ESFB0007891',
      name: 'Rahul Saxena',
      uniqueId: 'BEN020',
      cancelCheque: 'cheque_020.pdf',
      bankName: 'Equitas Small Finance Bank'
    },
    {
      id: 21,
      status: 'Pending',
      accountNumber: '9517534560',
      ifscCode: 'RATN0004567',
      name: 'Bhavna Yadav',
      uniqueId: 'BEN021',
      cancelCheque: 'cheque_021.pdf',
      bankName: 'RBL Bank'
    },
    {
      id: 22,
      status: 'Pending',
      accountNumber: '7531598520',
      ifscCode: 'CITI0001234',
      name: 'Deepak Malhotra',
      uniqueId: 'BEN022',
      cancelCheque: 'cheque_022.pdf',
      bankName: 'Citibank'
    },
    {
      id: 23,
      status: 'Pending',
      accountNumber: '4561237890',
      ifscCode: 'HSBC0009876',
      name: 'Isha Kapoor',
      uniqueId: 'BEN023',
      cancelCheque: 'cheque_023.pdf',
      bankName: 'HSBC Bank'
    },
    {
      id: 24,
      status: 'Approved',
      accountNumber: '3691472580',
      ifscCode: 'SCBL0007654',
      name: 'Varun Nair',
      uniqueId: 'BEN024',
      cancelCheque: 'cheque_024.pdf',
      bankName: 'Standard Chartered Bank'
    },
    {
      id: 25,
      status: 'Rejected',
      accountNumber: '2587413690',
      ifscCode: 'DEUT0008765',
      name: 'Simran Gill',
      uniqueId: 'BEN025',
      cancelCheque: 'cheque_025.pdf',
      bankName: 'Deutsche Bank'
    }
  ]);
  const [currentPage, setCurrentPage] = useState(1);
  const [showTPinModal, setShowTPinModal] = useState(false);
  const [selectedBeneficiary, setSelectedBeneficiary] = useState(null);
  const bankOptions = useMemo(() => {
    const uniqueBanks = Array.from(
      new Set(
        beneficiaries
          .map((beneficiary) => beneficiary.bankName)
          .filter((bankName) => typeof bankName === 'string' && bankName.trim() !== '')
      )
    );
    return uniqueBanks.map((bankName) => ({
      label: bankName,
      value: bankName
    }));
  }, [beneficiaries]);

  const statusTabs = [
    { label: 'Approved', value: 'Approved' },
    { label: 'Pending', value: 'Pending' },
    { label: 'Rejected', value: 'Rejected' }
  ];

  const pageSize = 6;
  const filteredBeneficiaries = beneficiaries.filter((beneficiary) => beneficiary.status === activeTab);
  const totalItems = filteredBeneficiaries.length;
  const totalPages = Math.max(1, Math.ceil(totalItems / pageSize));
  const startIndex = (currentPage - 1) * pageSize;
  const paginatedBeneficiaries = filteredBeneficiaries.slice(startIndex, startIndex + pageSize);
  const showingStart = totalItems === 0 ? 0 : startIndex + 1;
  const showingEnd = totalItems === 0 ? 0 : Math.min(totalItems, startIndex + paginatedBeneficiaries.length);

  useEffect(() => {
    if (currentPage > totalPages) {
      setCurrentPage(totalPages);
    }
  }, [totalPages, currentPage]);

  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    // Reset form
    setFormData({
      accountNumber: '',
      confirmAccountNumber: '',
      ifscCode: '',
      name: '',
      bankName: '',
      branchName: '',
      cancelCheque: null
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFileChange = (e) => {
    setFormData(prev => ({
      ...prev,
      cancelCheque: e.target.files[0]
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (formData.accountNumber !== formData.confirmAccountNumber) {
      alert('Account numbers do not match!');
      return;
    }

    if (!formData.accountNumber || !formData.ifscCode || !formData.name) {
      alert('Please fill all required fields');
      return;
    }

    // Simulate API call
    alert(`Beneficiary ${formData.name} added successfully!`);
    handleCloseModal();
  };

  const getStatusColor = (status) => {
    switch(status) {
      case 'Approved': return 'success';
      case 'Pending': return 'warning';
      case 'Rejected': return 'danger';
      default: return 'secondary';
    }
  };

  const columnCount = 6;
  const tableColumnCount = activeTab === 'Approved' ? columnCount + 1 : columnCount;

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleTransferClick = (beneficiary) => {
    setSelectedBeneficiary(beneficiary);
    setShowTPinModal(true);
  };

  const handleVerifyTpin = async ({ amount, bank }) => {
    if (!selectedBeneficiary) {
      return;
    }

    await new Promise((resolve) => setTimeout(resolve, 800));

    showToast.success(
      `Payout initiated for ${selectedBeneficiary.name} to ${bank} for ₹${amount}.`
    );
    setShowTPinModal(false);
    setSelectedBeneficiary(null);
  };

  const handleCloseTPinModal = () => {
    setShowTPinModal(false);
    setSelectedBeneficiary(null);
  };

  return (
    <Container fluid className="payout-beneficiary-page p-4">
      {/* Beneficiary Table */}
      <Row>
        <Col>
          <Card className="shadow-sm border-0">
            <Card.Header className="bg-white border-bottom" style={{ padding: '16px 24px' }}>
              <div className="d-flex justify-content-between align-items-center">
                <h5 className="mb-0" style={{ fontWeight: 600, color: '#2c2268' }}>
                  <i className="bi bi-people me-2"></i>
                  Payout Beneficiary
                </h5>
                <Button
                  onClick={handleOpenModal}
                  style={{
                    backgroundColor: 'transparent',
                    border: '2px solid #0d6efd',
                    color: '#0d6efd',
                    padding: '8px 20px',
                    borderRadius: '6px',
                    fontWeight: 600,
                    fontSize: '14px',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = '#0d6efd';
                    e.currentTarget.style.color = 'white';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = 'transparent';
                    e.currentTarget.style.color = '#0d6efd';
                  }}
                >
                  <i className="bi bi-plus-circle me-2"></i>
                  Add Beneficiary
                </Button>
              </div>
            </Card.Header>
            <Card.Body className="p-0">
              <div className="d-flex align-items-center gap-2 px-3 py-3 border-bottom" style={{ backgroundColor: '#f8f9ff' }}>
                {statusTabs.map((tab) => {
                  const isActive = tab.value === activeTab;
                  return (
                    <Button
                      key={tab.value}
                      variant={isActive ? 'primary' : 'light'}
                      onClick={() => {
                        setActiveTab(tab.value);
                        setCurrentPage(1);
                      }}
                      style={{
                        fontWeight: 600,
                        fontSize: '13px',
                        borderRadius: '20px',
                        padding: '6px 18px',
                        border: isActive ? 'none' : '1px solid #dee2e6',
                        color: isActive ? '#fff' : '#2c2268'
                      }}
                    >
                      {tab.label}
                      {tab.value === 'Pending' && filteredBeneficiaries.length > 0 && activeTab === 'Pending' ? ` (${filteredBeneficiaries.length})` : ''}
                    </Button>
                  );
                })}
              </div>
              <div className="table-responsive">
                <Table hover className="mb-0">
                  <thead style={{ backgroundColor: '#f8f9fa' }}>
                    <tr>
                      {activeTab === 'Approved' && (
                        <th
                          style={{
                            padding: '12px 16px',
                            fontWeight: 700,
                            color: '#555',
                            borderBottom: '2px solid #dee2e6',
                            fontSize: '15px',
                            textAlign: 'center'
                          }}
                        >
                          Action
                        </th>
                      )}
                      <th style={{ padding: '12px 16px', fontWeight: 700, color: '#555', borderBottom: '2px solid #dee2e6', fontSize: '15px', textAlign: 'center' }}>
                        Account Number
                      </th>
                      <th style={{ padding: '12px 16px', fontWeight: 700, color: '#555', borderBottom: '2px solid #dee2e6', fontSize: '15px', textAlign: 'center' }}>
                        IFS Code
                      </th>
                      <th style={{ padding: '12px 16px', fontWeight: 700, color: '#555', borderBottom: '2px solid #dee2e6', fontSize: '15px', textAlign: 'center' }}>
                        Name
                      </th>
                      <th style={{ padding: '12px 16px', fontWeight: 700, color: '#555', borderBottom: '2px solid #dee2e6', fontSize: '15px', textAlign: 'center' }}>
                        Unique Id
                      </th>
                      <th style={{ padding: '12px 16px', fontWeight: 700, color: '#555', borderBottom: '2px solid #dee2e6', fontSize: '15px', textAlign: 'center' }}>
                        Cancel Cheque
                      </th>
                      <th style={{ padding: '12px 16px', fontWeight: 700, color: '#555', borderBottom: '2px solid #dee2e6', fontSize: '15px', textAlign: 'center' }}>
                        Status
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedBeneficiaries.length > 0 ? (
                      paginatedBeneficiaries.map((beneficiary) => (
                        <tr key={beneficiary.id} style={{ transition: 'background-color 0.2s' }}>
                          {activeTab === 'Approved' && (
                            <td style={{ padding: '12px 16px', textAlign: 'center' }}>
                              <Button
                                size="sm"
                                onClick={() => handleTransferClick(beneficiary)}
                                className="payout-transfer-btn"
                                variant="outline-primary"
                              >
                                Transfer To Bank
                              </Button>
                            </td>
                          )}
                          <td style={{ padding: '12px 16px', color: '#333', fontSize: '14px', fontWeight: 600, textAlign: 'center' }}>
                            {beneficiary.accountNumber}
                          </td>
                          <td style={{ padding: '12px 16px', color: '#666', fontSize: '14px', fontWeight: 500, textAlign: 'center' }}>
                            {beneficiary.ifscCode}
                          </td>
                          <td style={{ padding: '12px 16px', color: '#333', fontSize: '14px', fontWeight: 600, textAlign: 'center' }}>
                            {beneficiary.name}
                          </td>
                          <td style={{ padding: '12px 16px', color: '#666', fontSize: '14px', fontWeight: 500, textAlign: 'center' }}>
                            {beneficiary.uniqueId}
                          </td>
                          <td style={{ padding: '12px 16px', color: '#0d6efd', fontSize: '14px', fontWeight: 500, textAlign: 'center' }}>
                            <span className="d-inline-flex align-items-center justify-content-center gap-1">
                              <i className="bi bi-file-earmark-pdf"></i>
                              {beneficiary.cancelCheque}
                            </span>
                          </td>
                          <td style={{ padding: '12px 16px', textAlign: 'center' }}>
                            <Badge
                              bg={getStatusColor(beneficiary.status)}
                              style={{
                                fontSize: '11px',
                                padding: '4px 10px',
                                fontWeight: 500
                              }}
                            >
                              {beneficiary.status}
                            </Badge>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={tableColumnCount} className="text-center py-4" style={{ color: '#999' }}>
                          No beneficiaries found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
              {totalItems > 0 && (
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-2 px-3 py-3 border-top">
                  <span style={{ fontSize: '13px', color: '#666' }}>
                    Showing {showingStart}-{showingEnd} of {totalItems}
                  </span>
                  {totalPages > 1 && (
                    <Pagination className="mb-0">
                      <Pagination.Prev
                        disabled={currentPage === 1}
                        onClick={() => handlePageChange(currentPage - 1)}
                      />
                      {Array.from({ length: totalPages }, (_, index) => {
                        const pageNumber = index + 1;
                        return (
                          <Pagination.Item
                            key={pageNumber}
                            active={pageNumber === currentPage}
                            onClick={() => handlePageChange(pageNumber)}
                          >
                            {pageNumber}
                          </Pagination.Item>
                        );
                      })}
                      <Pagination.Next
                        disabled={currentPage === totalPages}
                        onClick={() => handlePageChange(currentPage + 1)}
                      />
                    </Pagination>
                  )}
                </div>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Add Beneficiary Modal */}
      <Modal
        show={showModal}
        onHide={handleCloseModal}
        centered
        size="lg"
        dialogClassName="retailer-modal"
      >
        <Modal.Header closeButton style={{ borderBottom: '1px solid #dee2e6', padding: '16px 24px' }}>
          <Modal.Title style={{ fontSize: '20px', fontWeight: 600, color: '#333' }}>
            Add Beneficiary
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: '24px' }}>
          <Form onSubmit={handleSubmit}>
            {/* Account Number */}
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Account Number <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="accountNumber"
                    placeholder="Enter Account Number"
                    value={formData.accountNumber}
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Confirm Account Number <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="confirmAccountNumber"
                    placeholder="Re-enter Account Number"
                    value={formData.confirmAccountNumber}
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            {/* IFS Code */}
            <Form.Group className="mb-3">
              <Form.Label>
                IFS Code <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                name="ifscCode"
                placeholder="Enter IFS Code"
                value={formData.ifscCode}
                onChange={handleInputChange}
                required
              />
            </Form.Group>

            {/* Name */}
            <Form.Group className="mb-3">
              <Form.Label>
                Beneficiary Name <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                name="name"
                placeholder="Enter Beneficiary Name"
                value={formData.name}
                onChange={handleInputChange}
                required
              />
            </Form.Group>

            {/* Bank Name and Branch Name */}
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Bank Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="bankName"
                    placeholder="Enter Bank Name"
                    value={formData.bankName}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Branch Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="branchName"
                    placeholder="Enter Branch Name"
                    value={formData.branchName}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>
            </Row>

            {/* Cancel Cheque Upload */}
            <Form.Group className="mb-3">
              <Form.Label>
                Upload Cancel Cheque <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="file"
                name="cancelCheque"
                onChange={handleFileChange}
                accept="image/*,.pdf"
                required
              />
              <Form.Text className="text-muted">
                Upload a scanned copy of cancelled cheque (PDF or Image)
              </Form.Text>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer style={{ borderTop: '1px solid #dee2e6', padding: '16px 24px' }}>
          <Button
            variant="secondary"
            onClick={handleCloseModal}
            style={{
              padding: '8px 20px',
              fontSize: '14px',
              fontWeight: 500,
              borderRadius: '4px'
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            style={{
              backgroundColor: 'transparent',
              border: '2px solid #0d6efd',
              color: '#0d6efd',
              padding: '8px 20px',
              fontSize: '14px',
              fontWeight: 600,
              borderRadius: '4px',
              transition: 'all 0.3s ease'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = '#0d6efd';
              e.currentTarget.style.color = 'white';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
              e.currentTarget.style.color = '#0d6efd';
            }}
          >
            Add Beneficiary
          </Button>
        </Modal.Footer>
      </Modal>

      <TPinModal
        show={showTPinModal}
        onHide={handleCloseTPinModal}
        onVerify={handleVerifyTpin}
        title="Confirm Payout"
        message={
          selectedBeneficiary
            ? `Enter the transfer amount, choose bank if needed, and confirm T-PIN for ${selectedBeneficiary.name}.`
            : 'Enter your T-PIN to continue.'
        }
        confirmLabel="Transfer To Bank"
        requireAmount
        amountLabel="Transfer Amount"
        amountPlaceholder="Enter transfer amount"
        amountMin={1}
        requireBankSelection
        bankLabel="Select Bank"
        bankPlaceholder="Select bank"
        bankOptions={bankOptions}
        defaultBank={selectedBeneficiary?.bankName || ''}
        contextDetails={
          selectedBeneficiary
            ? [
                { label: 'Beneficiary', value: selectedBeneficiary.name },
                { label: 'Account No', value: selectedBeneficiary.accountNumber },
                { label: 'IFSC', value: selectedBeneficiary.ifscCode }
              ]
            : []
        }
      />

      {/* Custom Styles */}
      <style jsx="true">{`
        .payout-beneficiary-page {
          background-color: #fff;
          min-height: calc(100vh - 100px);
        }

        .table tbody tr:hover {
          background-color: #f8f9fa;
        }

        .modal-content {
          border-radius: 8px;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
        }

        .payout-transfer-btn {
          border-radius: 999px;
          padding: 4px 14px;
          font-weight: 600;
          background-color: transparent;
          border: 2px solid #2563eb;
          color: #2563eb;
          font-size: 0.75rem;
          transition: all 0.2s ease;
          box-shadow: none;
        }

        .payout-transfer-btn:hover,
        .payout-transfer-btn:focus {
          background-color: #2563eb;
          color: #ffffff;
          border-color: #2563eb;
        }

        .payout-transfer-btn:disabled,
        .payout-transfer-btn.disabled {
          background-color: transparent;
          color: #9ca3af;
          border-color: #cbd5f5;
        }

        .modal-header .btn-close {
          padding: 0.5rem;
        }

        @media (max-width: 768px) {
          .table-responsive {
            overflow-x: auto;
          }
        }
      `}</style>
    </Container>
  );
};

export default PayoutBeneficiary;

